import axios from 'axios';

class FileService {
    uploadFile(file){
        const fileDataPromise = new Promise((resolve, reject) => {
            const formData = new FormData();
            console.log(file);
            formData.append('files', file);
            console.log(formData);
            axios.post('http://192.168.34.100:3200/', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                resolve(JSON.stringify(response.data));
            }).catch(e => {
                reject(e);
            });
        });
        return fileDataPromise;
    }

    getUrl(path){
        return 'http://192.168.34.100:3200/uploads/' + path;
    }

}

export default FileService;